import type { FunctionComponent, PropsWithChildren } from 'react';

import { L10nText } from '../../services/uiTranslations/reactBindings/L10nText';
import type { AllowedGlobals } from '../../utils/window';
import { Button, ButtonVariant } from '../controls/button/Button';
import { BlockingModalContent } from '../popup/content/BlockingModalContent';

import { ErrorBoundary } from './ErrorBoundary';

export const FinalErrorBoundary: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const windowObject = (window as AllowedGlobals).legacyMode ? window.parent : window;

  return (
    <ErrorBoundary
      fallback={
        <BlockingModalContent
          actions={[
            <Button
              key="OK"
              tk="OK"
              variant={ButtonVariant.ACCENT}
              onClick={(): void => {
                windowObject.location.reload();
              }}
            />,
          ]}
          inCurtain
        >
          <L10nText tk="GENERIC_ERROR" placeholder="Please contact Customer Support for assistance" />
        </BlockingModalContent>
      }
      critical
    >
      {children}
    </ErrorBoundary>
  );
};
